import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { ajax } from "jquery";

import ElementMessage from '../../components/common/elementmessage';
import InlineData from '../../components/forms/inlinedata';
import Button from '../../components/forms/button';
import * as CONST from '../../helpers/const';
import Utils from '../../helpers/utils';

const FilterForm = (props) => {

    const [selectedBunrui1, setSelectedBunrui1] = useState(0);
    const [bunruiList, setBunruiList] = useState([]);
    const [filterProductName, setFilterProductName] = useState("");
    const [orderByField, setOrderByField] = useState(CONST.OrderByField.CATEGORY);
    const [sortOrder, setSortOrder] = useState(CONST.SortOrder.ASC);

    useEffect(() => {
        setBunruiList(props.bunrui1Options);
        findProducts();
    }, []);

    useEffect(() => {
        setBunruiList(props.bunrui1Options);
    }, [props.bunrui1Options])

    function findProducts() {
        $("#loading").fadeIn();
        let bunrui = null
        if (
        Array.isArray(bunruiList) &&
        selectedBunrui1 != null &&
        selectedBunrui1 >= 0 &&
        selectedBunrui1 < bunruiList.length
        ) {
        bunrui = bunruiList[selectedBunrui1].BunruiCode;
        }

        // let selectedProducts = [];
        // props.newProducts.forEach(row => {
        //     if (row.IraiQt != null && row.IraiQt > 0 && !row.SpotFlg) {
        //         selectedProducts.push(row);
        //     }
        // });

        var filterModel = {
            Bunrui1Code: bunrui,
            HansokuName: filterProductName,
        };

        ajax({
            url: props.GetProductsByFilterUrl,
            type: 'POST',
            data: { 'filterData': filterModel },
            credentials: 'same-origin'
        }).done(json => {
            let result = JSON.parse(json);
            if (result.Status === CONST.ApiResult.Success) {
                let list = result.Response;
                if (null != list) {
                    // if (null != selectedProducts) {
                    //     list = list.filter(x => false == selectedProducts.some(h => h.HansokuId == x.HansokuId));
                    //     list = selectedProducts.concat(list);
                    // }
                    list.sort(function (a, b) {
                        let objA = a[orderByField] ? a[orderByField] : "";
                        let objB = b[orderByField] ? b[orderByField] : "";
                        return sortOrder == CONST.SortOrder.ASC ? objA.localeCompare(objB) : objB.localeCompare(objA);
                    });
                } 
                props.setNewProducts(list);
            }
        }).always(json => {
            $("#loading").fadeOut();
        })

    }

    const labelStyle = {
        width: '87px',
        minWidth: '87px',
        display: "inline-block",
        textAlign: 'left'
    }

    return (
        <div>

                <div className="row form-group">
                    <div className="col-md-3 col-sm-3 input-group-text" >
                        <label htmlFor="classification" style={labelStyle}>{props.getTranslateValue(props.translate.current, "views.ihn0101.classification")}</label>
                        <select className="multiselect dropdown-toggle input-group-text" name="bunrui" value={selectedBunrui1} onChange={e => setSelectedBunrui1(e.target.value)} style={{ flexGrow: "1", textAlign: "left", minWidth: "0" }}>
                            {bunruiList &&
                                bunruiList.map(function (option, index) {
                                    return <option key={index} value={option.value}>{option.label}</option>
                                })
                            }
                        </select>
                    </div>
                     <div className="col-md-4 col-sm-4 input-group-text">
                        <label htmlFor="product" style={labelStyle}>{props.getTranslateValue(props.translate.current, "views.ihn0101.product")}</label>
                        <input type="text" className="form-control" name="selectcode" value={filterProductName} onChange={e => setFilterProductName(e.target.value)} />
                    </div>
                    <div className="col-md-3 col-sm-3 pull-right">
                        <Button color="success" style={{ marginTop: "5px", width: "100px", display: "flex", flexDirection: "row-reverse", justifyContent: "center", alignItems: "center", gap: "5px" }}
                         icon="fa-search" divClassName="pull-right" divStyle={{}} className="flex-grow-0" label={props.getTranslateValue(props.translate.current, "views.ihn0101.search")} onClick={findProducts.bind(this)} />
                    </div>
                </div>

        </div>
    )

}

export default FilterForm;


// WEBPACK FOOTER //
// ./view/IHN0101/IHN0101-filter.jsx